import React from "react";
import { CV } from "../components/cv";
import WilliamPImg from "@/assets/images/william-p.png";

export default function CVWilliamPhan() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - William Phan";
  }, []);

  return (
    <CV
      name="William Phan"
      photo={WilliamPImg}
      title="Fullstack Developer & DevOps Engineer"
      subtitle="Fullstack and CI/CD across Java, TypeScript and Scala — React and Next.js frontends, Spring and Play backends, Kubernetes/OpenShift platforms on GCP and AWS."
      summary="Fullstack developer passionate for trying out and learning new things every day. Goal is to explore every corner of the application stack, everything from frontend to backend, managing databases to maintaining infrastructure. Ten years of consulting and in-house engineering at Skatteverket, Apple and IKEA — building services for cross-border tax information exchange, in-house CI/CD platforms with developer experience as the main focus, and e-commerce web projects across IKEA.com sales and payment flows. Comfortable moving between React/Next.js frontends, Java/Scala/Go backends and the Terraform, Jenkins and Kubernetes plumbing that ships them. In spare time enjoys a good match of tennis."
      skills={{
        "Programming Languages": [
          "Java",
          "JavaScript",
          "TypeScript",
          "Scala",
          "Python",
          "Go",
          "Groovy",
        ],
        "Frontend": ["React", "Next.js", "Apollo GraphQL", "HTML", "CSS"],
        "Backend": ["Spring", "Scala Play", "Microservices", "REST", "JSP"],
        "CI/CD & Build": ["Jenkins", "Gradle", "Ansible"],
        "Containers & Platforms": ["Docker", "Kubernetes", "OpenShift (OCP)"],
        "Cloud & Infrastructure": ["GCP", "AWS", "Terraform", "Akamai"],
        "Data": ["Hadoop", "Spark", "GIS"],
        Languages: ["Swedish", "English", "Mandarin", "Cantonese"],
      }}
      experience={[
        {
          role: "Parental leave",
          company: "",
          period: "2026",
          description: "",
          highlights: [],
        },
        {
          role: "Software Engineer (Consultant)",
          company: "Skatteverket, Malmö",
          period: "2023 – 2025",
          description:
            "Fullstack across multiple services for exchanging tax information with other jurisdictions and processing and analyzing data to be used by tax administrators.",
          highlights: [
            "Java, JavaScript/TypeScript, Groovy, React, Spring, OCP, Jenkins, Gradle.",
          ],
        },
        {
          role: "Software Engineer / DevOps (Consultant)",
          company: "Apple, Malmö",
          period: "2021 – 2022",
          description:
            "Fullstack for an in-house CI/CD service handling releases, deployments and life cycle with “developer experience” as main focus.",
          highlights: [
            "Improved infrastructure tools and backend services, and supported other teams with CI/CD.",
            "JavaScript/TypeScript, Scala, Java, Python, React, Scala Play, Jenkins, Gradle, Kubernetes.",
          ],
        },
        {
          role: "DevOps Engineer",
          company: "IKEA IT AB, Malmö",
          period: "2019 – 2021",
          description:
            "Fullstack in multiple web projects across IKEA.com — sales and payment.",
          highlights: [
            "Frontend development and setting up CI/CD in GCP/AWS. Created tooling and scripts for various subtasks, e.g. analytics.",
            "Backend development and setup in GCP for microservices connecting with external service partners.",
            "TypeScript, Go, Java, React, Next.js, Apollo GraphQL, Terraform, GCP, AWS, Akamai.",
          ],
        },
        {
          role: "Software Engineer / DevOps (Consultant)",
          company: "Apple, Malmö",
          period: "2017 – 2019",
          description:
            "Data validation and developer tooling for in-house engines where performance was the key.",
          highlights: [
            "Developed algorithms for validating large data sets using in-house engines.",
            "Improved infrastructure tooling, common services and builds used by other teams and supported them in improving their development life cycles.",
            "Scala, JavaScript, Java, Python, Groovy, GIS, Jenkins, Gradle, Docker, Kubernetes, Hadoop, Spark, Ansible.",
          ],
        },
        {
          role: "Webmaster (volunteer)",
          company: "Art for Charity, Malmö",
          period: "2015 – 2017",
          description:
            "Updated website with new content according to the customer’s needs using their CMS and some customization.",
          highlights: ["HTML, CSS."],
        },
        {
          role: "Software Developer (Consultant)",
          company: "IKEA IT AB, Helsingborg",
          period: "2015 – 2017",
          description:
            "Developed customization for Oracle WebCenter Sites (CMS).",
          highlights: ["Java, JSP, JavaScript."],
        },
        {
          role: "Software Engineer",
          company: "Devv.it, Helsingborg",
          period: "2014",
          description: "Developed a mobile app for an advertising company.",
          highlights: ["Server/client solution, PHP, JavaScript, jQuery."],
        },
        {
          role: "Teaching Assistant",
          company: "Faculty of Engineering (LTH), Lund University",
          period: "2013 – 2014",
          description:
            "Supervision of students in the basic and second Java courses.",
          highlights: [],
        },
      ]}
      education={[
        {
          degree: "Computer Science and Engineering, Bachelor of Science",
          institution:
            "Faculty of Engineering (LTH) at Campus Helsingborg, Lund University",
          year: "2012 – 2015",
        },
      ]}
    />
  );
}
